import JSZip from 'jszip';

import { downloadBlob } from '../../utils/downloadBlob.ts';

export async function downloadZip(
  files: { blob: Blob; name: string }[],
  zipName: string,
): Promise<void> {
  const zip = new JSZip();

  for (const file of files) {
    zip.file(file.name, file.blob);
  }

  const zippedFile = await zip.generateAsync({ type: 'blob' });
  downloadBlob(zippedFile, `${zipName}.zip`);
}
